import { render, staticRenderFns } from "./SchoolAwayDetailTableControl.vue?vue&type=template&id=7336026b&scoped=true&"
import script from "./SchoolAwayDetailTableControl.vue?vue&type=script&lang=js&"
export * from "./SchoolAwayDetailTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7336026b",
  null
  
)

export default component.exports